import anime from 'animejs/lib/anime.min.js';

export default class SiteNavSearch {
	constructor() {
		this.$root = document.getElementById('siteNavSearch');
		this.$btn = null;
		this.$searchField = null;
		this.$searchInput = null;
		this.$logo = null;

		this.siteLang = document.querySelector('html').lang;
		this.active = false;

		this.SEARCH_FIELD_INITIAL_WIDTH = 37;
		this.SEARCH_FIELD_ACTIVE_WIDTH = 209;

		this.searchByPressEnter = this.searchByPressEnter.bind(this);

		this.init();
	}

	init() {
		if (this.$root == null) {
			throw new Error('SiteNavSearch: Root element is not defined');
		}

		this.$btn = this.$root.querySelector('.site-nav-search_btn');
		this.$searchField = this.$root.querySelector('.site-nav-search_field');
		this.$searchInput = this.$root.querySelector('.site-nav-search_input');

		this.addEventListeners();
	}

	addEventListeners() {
		this.$btn.addEventListener('click', () => {
			if (this.active) {
				if (this.$searchInput.value.length) {
					location.href = location.origin + (this.siteLang === 'ru' ? '/ru' : '') + '/search?q=' + this.$searchInput.value;
				}
			} else {
				this.showSearchField();
			}
		});

		window.addEventListener('click', (e) => {
			if (e.target.closest('#siteNavSearch') || !this.active) {
				return;
			}

			this.hideSearchField();
		});
	}

	searchByPressEnter(e) {
		if (e.key === 'Enter' && this.$searchInput.value.length) {
			location.href = location.origin + (this.siteLang === 'ru' ? '/ru' : '') + '/search?q=' + this.$searchInput.value;
		}
	}

	showSearchField() {
		this.active = true;
		this.$root.classList.add('-active');
		this.$searchField.style.opacity = 0;
		this.$searchField.style.display = 'block';

		this.$searchInput.addEventListener('keyup', this.searchByPressEnter);
		this.$searchInput.focus();

		const fadeLogoMedia = window.matchMedia('(max-width: 1000px)').matches;

		anime({
			targets: this.$searchField,
			opacity: 1,
			duration: 360,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		});

		anime({
			targets: this.$root,
			width: this.SEARCH_FIELD_ACTIVE_WIDTH + 'px',
			duration: 360,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		});

		if (fadeLogoMedia) {
			if (this.$logo == null) {
				this.$logo = document.querySelector('.site-header:not(.-pinned) .site-header-logo');
			}

			this.$logo.classList.add('-faded');
		}
	}

	hideSearchField() {
		this.active = false;
		this.$root.classList.remove('-active');
		this.$searchInput.removeEventListener('keyup', this.searchByPressEnter);

		if (this.$logo != null) {
			this.$logo.classList.remove('-faded');
		}

		anime({
			targets: this.$searchField,
			opacity: 0,
			duration: 250,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
			complete: (anim) => {
				if (anim.completed) {
					this.$searchField.style.display = 'none';
				}
			}
		});

		anime({
			targets: this.$root,
			width: this.SEARCH_FIELD_INITIAL_WIDTH + 'px',
			duration: 360,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		});
	}
}